import React, { useEffect, useMemo, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { api } from "@/lib/api";
import { PageHeader, Empty } from "@/components/common";
import { Button } from "@/components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Printer, QrCode, Search } from "lucide-react";

export default function KartuQrPendidik() {
  const [list, setList] = useState([]);
  const [fCat, setFCat] = useState("all");
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/educators").then((r) => setList(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(
    () => list.filter((e) =>
      (fCat === "all" || e.category === fCat) &&
      (e.name.toLowerCase().includes(query.toLowerCase()) || (e.nik || "").includes(query) || (e.pin || "").includes(query))
    ),
    [list, fCat, query]
  );

  return (
    <div>
      <PageHeader
        title="Kartu QR Pendidik"
        subtitle="Cetak kartu QR untuk identifikasi pendidik & kependidikan di Kopontren. QR berisi PIN pendidik."
        action={
          <Button onClick={() => window.print()} data-testid="print-qr-pendidik-button" className="bg-emerald-600 hover:bg-emerald-700 rounded-xl no-print">
            <Printer size={18} className="mr-2" /> Cetak ({filtered.length})
          </Button>
        }
      />

      <div className="flex flex-wrap gap-3 mb-6 no-print">
        <Select value={fCat} onValueChange={setFCat}>
          <SelectTrigger data-testid="qr-pendidik-filter-cat" className="w-44 rounded-xl bg-white"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Semua Kategori</SelectItem>
            <SelectItem value="pendidik">Pendidik</SelectItem>
            <SelectItem value="kependidikan">Kependidikan</SelectItem>
          </SelectContent>
        </Select>
        <div className="relative flex-1 min-w-[200px] max-w-xs">
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
          <input value={query} onChange={(e) => setQuery(e.target.value)} data-testid="qr-pendidik-search" placeholder="Cari nama / NIK / PIN…" className="w-full pl-10 h-10 rounded-xl bg-white border border-stone-200 text-sm outline-none focus:border-emerald-400" />
        </div>
      </div>

      {loading ? (
        <p className="text-stone-400">Memuat…</p>
      ) : filtered.length === 0 ? (
        <Empty><QrCode className="mx-auto mb-2" /> Tidak ada pendidik sesuai filter.</Empty>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {filtered.map((e) => (
            <div key={e.id} data-testid={`qr-pendidik-card-${e.id}`} className="qr-card bg-white border border-stone-200 rounded-2xl p-4 shadow-sm text-center">
              <p className="font-heading font-bold text-stone-900 leading-tight truncate">{e.name}</p>
              <p className="text-[11px] text-stone-400 truncate mb-3">{e.jabatan || "-"}</p>
              <div className="flex justify-center">
                <QRCodeCanvas value={e.pin} size={128} level="M" includeMargin />
              </div>
              <div className="mt-3 flex items-center justify-center gap-2 text-[11px]">
                <span className={`px-2 py-0.5 rounded-full font-semibold ${e.category === "kependidikan" ? "bg-sky-100 text-sky-700" : "bg-emerald-100 text-emerald-700"}`}>
                  {e.category === "kependidikan" ? "Kependidikan" : "Pendidik"}
                </span>
                <span className="text-stone-400 font-mono">PIN {e.pin}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
